<template>
    <Custom-Select
      v-model="list"
      :label="label"
      :items="days"
      multiple
    />
  </template>
  
  
  <script>
  export default {
    name: 'Days',
    props: {
      value: {
        required: true,
      },
      label: {
        type: String,
        default: 'Дни',
      },
    },
  
    data() {
      return {
        days: [
          {id: '1', name: 'Понедельник'},
          {id: '2', name: 'Вторник'},
          {id: '3', name: 'Среда'},
          {id: '4', name: 'Четверг'},
          {id: '5', name: 'Пятница'},
          {id: '6', name: 'Суббота'},
          {id: '7', name: 'Воскресенье'},
        ],
      }
    },
  
    computed: {
      list: {
        get() {
          return this.value
        },
        set(item) {
          this.$emit('input', item)
        },
      },
    },
  }
  </script>